import { isSupplyType } from "src/util/allocations";
import { getGroupType } from "src/util/groupType";

export type IsTeamInsightsAvailableArgs = {
  /** Team insights gate (`enableTeamInsights`, auto-on while org design is on). */
  insightsEnabled: boolean;
  team?:
    | {
        type?: string | null;
        isHidden?: boolean | null;
        isDeleted?: boolean | null;
      }
    | null
    | undefined;
  groupTypes?: Record<string, unknown> | null | undefined;
};

export const isTeamInsightsAvailableForTeam = ({
  insightsEnabled,
  team,
  groupTypes,
}: IsTeamInsightsAvailableArgs): boolean => {
  if (!insightsEnabled || !team?.type) {
    return false;
  }
  if (team.isHidden || team.isDeleted) {
    return false;
  }
  // Demand teams remain excluded until their ownership semantics are defined.
  return isSupplyType(getGroupType(team, groupTypes));
};
